module.exports = __webpack_public_path__ + "static/g-3-ed1da425f7f8e402403359a4caa91cc3.jpg";